import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Constants } from 'src/constants';
import { CommonService } from '../common.service';
import { DevService } from '../dev.service';
import { NavigationService } from '../navigation.service';
import { SupportToolsService } from '../support-tools.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard {
  constructor(
    private _commonService: CommonService,
    private _navigationService: NavigationService,
    private _devService: DevService,
    private _supportToolsService: SupportToolsService
  ) {}

  // eslint-disable-next-line complexity
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    switch (state.url) {
      case Constants.ROUTE_SUPPORT_TOOLS_CLEAR_API_CACHE:
      case Constants.ROUTE_SUPPORT_TOOLS_QUERY_BUILDER: {
        const canNavigate = this._supportToolsService.showSupportTools;
        if (canNavigate) return true;

        this._navigationService.navigate(Constants.ROUTE_BASE);
        return false;
      }

      case Constants.ROUTE_PAYMENTS_TYPES: {
        const is_enabled = this._commonService.feat_Payments;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_PAYMENTS_LINK_WITH_PAYMENT_PROVIDER: {
        const is_enabled = this._commonService.feat_Payments && this._commonService.isL4OrHigher;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_PAYMENTS_SETTINGS: {
        const is_enabled = this._commonService.isL4OrHigher && this._commonService.feat_Payments;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_CUSTOMISE_PRACTITIONERS: {
        const is_enabled = this._commonService.feat_CustomisePractitioners;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_CUSTOMISE_BRANDS: {
        const is_enabled = this._commonService.feat_CustomiseBrands;

        if (!is_enabled) this._navigationService.navigate('customise');
        return is_enabled;
      }

      case Constants.ROUTE_CUSTOMISE_PORTAL: {
        const is_enabled = this._commonService.feat_CustomisePortal;

        if (!is_enabled) this._navigationService.navigate('customise');
        return is_enabled;
      }

      case Constants.ROUTE_CUSTOMISE_SETTINGS: {
        const is_enabled =
          this._commonService.isL4OrHigher &&
          (this._commonService.feat_CustomiseBrands || this._commonService.feat_CustomisePortal || this._commonService.feat_CustomisePractitioners);

        if (!is_enabled) this._navigationService.navigate('customise');
        return is_enabled;
      }

      case Constants.ROUTE_PATIENT_NOTIFICATION_SETTINGS: {
        const is_enabled = this._commonService.isL4OrHigher;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_DEV_MODE_BULK_DATA: {
        const is_enabled = this._devService.isUserDev;

        if (!is_enabled) this._navigationService.navigate(Constants.ROUTE_BASE);
        return is_enabled;
      }

      case Constants.ROUTE_DEVICES_SETTINGS:
      case Constants.ROUTE_DEVICES_PAIR: {
        //allow everyone to see the page - they won't be able to pair anyway
        return true;
      }

      default:
        return true;
    }
  }
}
